<template>
  <div class="font bg-organization" >
    <b-container class='mt-4 px-0'>
      <b-row>
        <b-col cols='7' class='mx-auto mt-4 ml-3 font-org-right-blue'>
          <h4><b-icon icon="files" class='mr-2'></b-icon>求職者詳細</h4>
        </b-col>
        <b-col cols='5' class='mx-auto mt-4 px-4 text-right'>
          <AgencyList v-if="isAgency" @update="onUpdateAll" :currentOrg="1"></AgencyList>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols='10' class='mx-auto mt-5'>
          <b-row>
            <router-link to="./mypage" class='text-orange'>{{$t("message.back_mypage")}}</router-link>
          </b-row>

          <b-row class='mt-4 pb-2'>
            <b-col cols='6' class='mx-auto text-center'>
              <div class="float-left" v-show="recruits.length > 0 && recruits[0].fase != 'offer' && recruits[0].fase != 'reject'">
                <router-link v-if="isAgency" :to="'/agency/mail-box?u_id=' + userInfo.id">
                  <b-button pill class='table-edit-button'>チャット</b-button>
                </router-link>
                <router-link v-else :to="'/organization/mail-box?u_id=' + userInfo.id">
                  <b-button pill class='table-edit-button'>チャット</b-button>
                </router-link>
              </div>
              <div class="float-left" v-show="recruits.length > 0 && recruits[0].fase != 'offer' && recruits[0].fase != 'reject'">
                <router-link v-if="isAgency" :to="'/agency/mail-box?u_id=' + userInfo.id">
                  <b-button pill class='table-edit-button'>面接日程調整</b-button>
                </router-link>
                <router-link v-else :to="'/organization/mail-box?u_id=' + userInfo.id">
                  <b-button pill class='table-edit-button'>面接日程調整</b-button>
                </router-link>
              </div>
              <b-button  v-show="recruits.length == 0" @click='showScoutModal' pill class='table-edit-button float-left'>スカウトを送る</b-button>
              <b-button v-if="!isFavorite" pill @click="onPostFavorite" class='table-edit-button float-left'>お気に入り</b-button>
              <b-button v-else pill @click="onDestroyFavorite" class='table-edit-button float-left'>お気に入りからはずす</b-button>
            </b-col>
          </b-row>

          <b-row class='mt-5'>
            <b-col cols='7' class='px-0'>
              <b-row class="b-top pt-2">
                <b-col cols='2' >
                  <label >{{$t("message.name")}}</label>
                </b-col>
                <b-col cols='5'>
                  <label >{{ getName() }} </label>
                </b-col>
              </b-row>

              <b-row class="b-bottom pt-2">
                <b-col cols='2' >
                  <label >{{$t("message.furigana")}}</label>
                </b-col>
                <b-col cols='5'>
                  <label >{{ userInfo.name_kana }} </label>
                </b-col>
              </b-row>

              <b-row class="b-bottom pt-2">
                <b-col cols='2' >
                  <label >{{$t("message.year_old")}}</label>
                </b-col>
                <b-col cols='5'>
                  <label >{{ userInfo.age }}歳 </label>
                </b-col>
              </b-row>

              <b-row class="b-bottom pt-2">
                <b-col cols='2' >
                  <label >{{$t("message.gender")}}</label>
                </b-col>
                <b-col cols='5'>
                  <label >{{ getGender(userInfo.gender) }} </label>
                </b-col>
              </b-row>

              <b-row class="b-bottom pt-2">
                <b-col cols='2' >
                  <label >{{$t("message.country_of_citizenship")}}</label>
                </b-col>
                <b-col cols='5'>
                  <label >{{ userInfo.nationality }}</label>
                </b-col>
              </b-row>

              <b-row class="b-bottom pt-2">
                <b-col cols='2' >
                  <label >{{$t("message.now_address")}}</label>
                </b-col>
                <b-col cols='5'>
                  <label >{{ userInfo.live_area }}</label>
                </b-col>
              </b-row>

              <b-row class="b-bottom pt-2">
                <b-col cols='2' >
                  <label >{{$t("message.history_in_japan")}}</label>
                </b-col>
                <b-col cols='5'>
                    <label >{{ userInfo.experience_japan }}年</label>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols='4' class='px-0 user-box'>
              <img class="user-img m-0" alt="" :src="userInfo.profile_image">
            </b-col>
            <b-col cols='12' class='px-0'>
              <b-row class="b-bottom pt-2">
                <b-col cols='2' >
                  <label >{{$t("message.career")}}</label>
                </b-col>
                <b-col cols='5'>
                  <label >{{ userInfo.simple_resume }}</label>
                </b-col>
              </b-row>

              <b-row class="b-bottom pt-2">
                <b-col cols='2' >
                  <label >{{$t("message.level_japanese")}}</label>
                </b-col>
                <b-col cols='5'>
                  <label >{{ JAPANESELIST[userInfo.japanese_skil] }}</label>
                </b-col>
              </b-row>

              <b-row class="b-bottom pt-2">
                <b-col cols='2' >
                  <label >{{$t("message.drivers_license")}}</label>
                </b-col>
                <b-col cols='5'>
                    <label v-if="userInfo.is_driver_licence"> 有り </label>
                    <label v-else> なし </label>
                </b-col>
              </b-row>

              <b-row class="b-bottom pt-2">
                <b-col cols='2' >
                  <label >自己PR</label>
                </b-col>
                <b-col cols='5'>
                    <label >{{ userInfo.self_pr }} </label>
                </b-col>
              </b-row>

              <b-row class="b-bottom pt-2 pb-5 mb-5">
                <b-col cols='2' >
                  <label >{{$t("message.pr_movie")}}</label>
                </b-col>
                <b-col cols='5'>
                  <video controls autoplay v-if="userInfo.intro_movie" class="video" :key="userInfo.intro_movie">
                    <source :src="userInfo.intro_movie" type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'>
                  </video>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-modal v-model='scoutModal' hide-header infomodal hide-footer size='lg'>
        <div class="row mt-4">
          <div class="col-10 text-center mb-4">
            <h4 >{{ $t('message.scout')}}</h4>
          </div>
          <div class="col-2 px-3 text-right">
            <button class="btn btn-md mb-0 p-0" @click="closeScoutModal()"><h3>×</h3></button>
          </div>
          <div class="col-3 ">
            <p >{{ $t('message.select_job')}}</p>
          </div>
          <div class="col-9 ">
            <b-form-select v-model="jobId" :options="options"></b-form-select>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-3 mx-auto">
            <p>{{ $t("message.scout_comment") }}</p>
          </div>
          <div class="col-9 ">
            <b-form-textarea v-model="comment"></b-form-textarea>
          </div>
        </div>
        <div class="col-12 px-3 text-center mt-4">
          <b-button @click='sendScout' pill class='bg-light-blue'>{{$t("message.send")}}</b-button>
        </div>
      </b-modal>
    </b-container>
  </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import AgencyList from "@/components/Agency/AgencyList"
export default {
  components: { AgencyList },
  data() {
    return{
      idToken: localStorage.idToken,
      uId: this.$route.params.uId,
      userInfo: [],
      scoutModal: false,
      jobId: '',
      options: [],
      recruits: [],
      isFavorite: false,
      favorite: {},
      isAgency: false,
    }
  },
  methods:{
    showScoutModal(){
      this.scoutModal = true;
    },
    closeScoutModal(){
      this.scoutModal = false;
    },
    checkAgency() {
      var idToken = localStorage.idToken
      try {
        axios.get(process.env.VUE_APP_API + "/api/agcy/agency/1", {headers: {'Authorization': 'Bearer ' + idToken}})
          .then(() => { this.isAgency = true})
      } catch(e) {
        console.log("---")
        console.log(e)
      }
    },
    getName(){
      var result =''
      if(this.userInfo.first_name != null){
        result += this.userInfo.first_name
      }
      if(this.userInfo.sur_name != null){
        result += ' ' + this.userInfo.sur_name
      }
      if(this.userInfo.last_name != null){
        result += ' ' + this.userInfo.last_name
      }
      return result
    },
    birth2age(day) {
      if( day != null){
        var birth = moment(day);
        return moment().diff(birth, 'years') + "歳";
      }
      return ''
    },
    getGender(gender){
      if(gender == "man"){
        return "男性"
      }else if(gender == "woman"){
        return "女性"
      }else{
        return "その他"
      }
    },
    onDestroyFavorite() {
      axios
        .delete(process.env.VUE_APP_API + "/api/org/favorite_users/" + this.favorite.id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.isFavorite = false
        }).catch(error => {
          console.log('this is org error', error)
        })
    },
    onPostFavorite() {
      axios
        .post(process.env.VUE_APP_API + "/api/org/favorite_users", {favorite_user: {user_id: this.userInfo.id}}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.isFavorite = true
        }).catch(error => {
          console.log('this is org error', error)
        })
    },
    sendScout(){
      var regist = {user_id: this.userInfo.id, message: this.scoutMessage, job_id: this.jobId}
      axios
      .post(process.env.VUE_APP_API + "/api/org/recruits", {recruit: regist}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(() => {
        this.closeScoutModal()
      }).catch(error => {
        console.log('this is org error', error)
      })
    },
    onUpdateAll() {
      this.$store.commit('setLoading', true)
      this.fetchUser()
      this.fetchJobs()
    },
    fetchUser() {
      axios
        .get(process.env.VUE_APP_API + "/api/org/users/" + this.uId, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.userInfo = response.data.user
          this.recruits = response.data.recruits

          this.favorite = response.data.favorite 
          if(this.favorite == null) {
            this.isFavorite = false
          } else {
            this.isFavorite = true
          }
          this.$store.commit('setLoading', false)
        }).catch(error => {
          console.log('this is org error', error)
        })
    },
    fetchJobs() {
      this.options = []
      axios
        .get(process.env.VUE_APP_API + "/api/org/jobs", {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          response.data.jobs.forEach((job)=> {
            console.log(job)
            this.options.push(
              { value: job.id , text: job.title }
            )
            this.$store.commit('setLoading', false)
          });
          this.$store.commit('setLoading', false)
        }).catch(error => {
          console.log('this is org error', error)
        })
    }
  },
  mounted(){
    this.fetchUser()
    this.fetchJobs()
    this.checkAgency()
  }
}

</script>
<style scoped type="scss">
.user-box{
  width: 8rem !important;
  height: 14rem !important;
}
.b-bottom {
  border-bottom: 1px solid #BCBBBB;
}
.b-top {
  border-top: 1px solid #BCBBBB;
}


.user-img {
  width: 100%;
  height: 210px;
  object-fit: cover;
  background-color: #777;
}
.video {
  width: 75%;
}
.float-left {
  float: left;
}
</style>
